import React from "react";
import { Users, Leaf, ShieldCheck, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { Link } from "@/components/common/Link";
const impactData = [{
  title: "PMP Certification",
  description: "The gold standard of project management excellence. Master the global language and lead complex projects with confidence.",
  stat: "Enquire Now",
  icon: ShieldCheck
}, {
  title: "PRINCE2 Training",
  description: "Process-based methodology for effective project management. Globally recognised standards for structured delivery.",
  stat: "Enquire Now",
  icon: Users
}, {
  title: "PMI-ACP Agile",
  description: "Advanced certification for agile practitioners. Expertise across Scrum, Kanban, Lean, and extreme programming.",
  stat: "Enquire Now",
  icon: Leaf
}];
export default function ImpactSocial() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="698" id="certification-cards" ref={ref} className="relative w-full py-40 bg-secondary overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(20,184,166,0.03),transparent_50%)]" />
        <div className="absolute top-0 left-0 w-full h-px bg-linear-to-r from-transparent via-border to-transparent" />
        <div className="absolute bottom-0 left-0 w-full h-px bg-linear-to-r from-transparent via-border to-transparent" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className={cn("text-center mb-24 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent text-accent-foreground text-xs font-bold tracking-widest uppercase mb-6 border border-accent-foreground/10">
            <span className="w-1.5 h-1.5 rounded-full bg-primary animate-pulse" />
            Professional Excellence
          </div>
          <h2 className="text-5xl md:text-7xl font-bold text-primary mb-8 tracking-tighter leading-[1.1] max-w-4xl mx-auto">
            Get Certified. <br className="hidden md:block" /> Deliver Better Projects.
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-xl leading-relaxed font-medium">
            Internationally recognised project management certifications — flexible online training designed for the modern working professional.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {impactData.map((item, i) => <div key={i} data-index={i} className={cn("transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16")} style={{
          transitionDelay: `${i * 200}ms`
        }}>
              <Card className="group h-full bg-white border border-border/50 shadow-sm hover:shadow-2xl hover:-translate-y-3 transition-all duration-500 overflow-hidden px-2">
                <CardHeader className="pt-10 pb-6">
                  <div className="mb-10 inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-secondary text-primary group-hover:bg-primary group-hover:text-white transition-colors duration-500">
                    <item.icon className="w-8 h-8 stroke-[1.25px]" />
                  </div>
                  <CardTitle className="text-2xl md:text-3xl font-bold text-primary tracking-tight mb-2">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-10 pb-10">
                  <p className="text-muted-foreground text-lg leading-relaxed">
                    {item.description}
                  </p>
                  <div className="pt-6 border-t border-border/50">
                    <Link to="/TrainingPage" className="group/link inline-flex items-center gap-3 text-sm font-bold text-primary uppercase tracking-widest hover:text-[#009485] transition-colors">
                      <span>{item.stat}</span>
                      <div className="w-8 h-8 rounded-full border border-border group-hover/link:border-[#009485] flex items-center justify-center transition-colors">
                        <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-0.5" />
                      </div>
                    </Link>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}